export default __webpack_public_path__ + "static/media/user-monitor.60e3ae37.svg";